"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _withThemeProps = _interopRequireDefault(require("../withThemeProps"));

/**
 * Zakladni IconButton wrapnuty Tooltip.
 *
 * @component
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var IconButtonWithTooltip = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      iconColor = _ref.iconColor,
      label = _ref.label,
      _ref$tooltipPlacement = _ref.tooltipPlacement,
      tooltipPlacement = _ref$tooltipPlacement === void 0 ? 'bottom' : _ref$tooltipPlacement,
      buttonProps = (0, _objectWithoutProperties2.default)(_ref, ["children", "iconColor", "label", "tooltipPlacement"]);
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: label,
    placement: tooltipPlacement
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_IconButton.default, (0, _extends2.default)({
    ref: ref
  }, buttonProps), /*#__PURE__*/_react.default.cloneElement(children, {
    color: iconColor
  }))));
});

process.env.NODE_ENV !== "production" ? IconButtonWithTooltip.propTypes = {
  /**
     * Icon
     */
  children: _propTypes.default.element.isRequired
} : void 0;
IconButtonWithTooltip.displayName = 'IconButtonWithTooltip';

var _default = (0, _withThemeProps.default)({
  name: 'SxIconButtonWithTooltip'
})(IconButtonWithTooltip);

exports.default = _default;